const bannerURLPaths = [
  '/henkiloasiakkaat/saastot-ja-sijoitukset',
  '/auth/saastot-ja-sijoitukset',
  '/privatkunder/sparande-och-placering',
  '/auth/sparande-och-placering',
  '/private-customers/savings-and-investments',
  '/web/corp/auth/investments',
  '/saastot-ja-sijoitukset/rahastot',
  '/sparande-och-placering/fonder',
  '/savings-and-investments/funds',
];

const corporateURLPaths = [
  '/web/corp/auth/sijoitukset',
  '/web/corp/auth/investments',
  '/web/corp/auth/placeringar',
  '/yritykset/sijoittaminen/sijoituslaskuri',
  '/sv/foretagskunder/placering/placeringsraknare',
  '/en/corporate-customers/investment/investment-calculator',
  '/yritykset/sijoittaminen/aloita-sijoittaminen',
  '/sv/foretagskunder/placering/borja-placera',
  '/en/corporate-customers/investment/start-investing',
];

const getPathFromUrl = (): string => {
  const path = window.location.pathname;
  return path;
};

export const isBannerLayout = (): boolean => {
  const windowPath = getPathFromUrl();
  const result = bannerURLPaths.find((path) => {
    return windowPath === path;
  });
  return !!result;
};

export const isCorporateUrl = (): boolean => {
  const windowPath = getPathFromUrl();
  const result = corporateURLPaths.find((path) => {
    return windowPath === path;
  });
  return !!result;
};
